import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {MatSelectModule} from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import { ConvertMoneyPipe } from './pipes/convert-money.pipe';
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { MatButtonModule } from '@angular/material/button';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FooterComponent } from './components/footer/footer.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { IntTelPickerComponent } from './components/int-tel-picker/int-tel-picker.component';
import { AnotherIntTelPickerComponent } from './components/another-int-tel-picker/another-int-tel-picker.component';
import { ContactIntTelPickerComponent } from './components/contact-int-tel-picker/contact-int-tel-picker.component';
import { NewDateFilterComponent } from './components/new-date-filter/new-date-filter.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomerSelectionComponent } from './components/customer-selection/customer-selection.component';
import { NameSortingComponent } from './components/name-sorting/name-sorting.component';
import { StatusFilterComponent } from './components/status-filter/status-filter.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateFormatPipe } from './pipes/date-format/date-format.pipe';
import { AgeFilterComponent } from './components/age-filter/age-filter.component';
import { DueDateFilterComponent } from './components/due-date-filter/due-date-filter.component';
import { MatInputModule } from '@angular/material/input';
import { AddActionButtonComponent } from './components/add-action-button/add-action-button.component';
import { HasAccessDirective } from './directives/has-access.directive';
import { PaymentDetailsDrawerComponent } from './components/payment-details-drawer/payment-details-drawer.component';
import { InvoiceLoaderDialogComponent } from '../main/modules/sell-management/components/invoice-loader-dialog/invoice-loader-dialog.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import {
  AppLabelComponent,
  AppInputComponent,
  AppSelectComponent,
  AppCheckboxComponent,
  AppPhoneInputComponent,
  AppRadioComponent,
  AppRadioGroupComponent,
  AppButtonComponent,
  AppPrimaryButtonComponent,
  AppSecondaryButtonComponent,
  AppEditButtonComponent,
  AppActionButtonComponent,
  AppBackButtonComponent,
  AppValueComponent,
  AppDetailFieldComponent,
  AppStepperComponent,
  AppSectionHeaderComponent,
  AppSearchBoxComponent,
  AppSelectFilterComponent,
  AppAmountFilterComponent,
  AppStatusFilterComponent,
  AppCardComponent,
  AppCardAvatarComponent,
  AppCardBadgeComponent,
  AppCardFieldComponent,
  AppCardChipComponent,
  AppCardProgressComponent,
  AppCardStatComponent,
  AppInvoiceCardComponent,
  AppPaymentCardComponent,
  AppWorkOrderCardComponent,
  AppDatePickerComponent,
  AppActionMenuComponent,
  AppActionMenuItemComponent,
  AppActionMenuHeaderComponent,
  AppActionMenuDividerComponent,
  AppTableComponent,
  AppTableTemplateDirective,
  AppProfitMarginFilterComponent,
  AppProductCardComponent,
  AppMultiSelectComponent,
  AppPriceUnitInputComponent,
  AppKpiCardComponent,
  AppQuarterlyMatrixComponent,
  AppMonthSelectorComponent,
  AppFinancialYearFilterComponent,
  AppSearchableDropdownComponent,
  AppStatusBadgeComponent,
  AppEditIconButtonComponent,
  AppDeleteIconButtonComponent,
  AppAuditTrailComponent,
  AppAuditTrailNodeComponent,
  AppAuditTrailEntryComponent,
} from './components/ui';
import { ToastComponent } from './components/toast/toast.component';
import { MAT_DATE_FORMATS } from '@angular/material/core';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',   // 👈 20-Sep-2025
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD-MMM-YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@NgModule({
  declarations: [
    HeaderComponent,
    SideMenuComponent,
    ConvertMoneyPipe,
    PaginatorComponent,
    FooterComponent,
    IntTelPickerComponent,
    AnotherIntTelPickerComponent,
    ContactIntTelPickerComponent,
    NewDateFilterComponent,
    CustomerSelectionComponent,
    NameSortingComponent,
    StatusFilterComponent,
    DateFormatPipe,
    AgeFilterComponent,
    DueDateFilterComponent,
    AddActionButtonComponent,
    HasAccessDirective,
    PaymentDetailsDrawerComponent,
    InvoiceLoaderDialogComponent,
    AppLabelComponent,
    AppInputComponent,
    AppSelectComponent,
    AppSearchableDropdownComponent,
    AppCheckboxComponent,
    AppPhoneInputComponent,
    AppRadioComponent,
    AppRadioGroupComponent,
    AppButtonComponent,
    AppPrimaryButtonComponent,
    AppSecondaryButtonComponent,
    AppEditButtonComponent,
    AppActionButtonComponent,
    AppBackButtonComponent,
    AppValueComponent,
    AppDetailFieldComponent,
    AppStepperComponent,
    AppSectionHeaderComponent,
    AppSearchBoxComponent,
    AppSelectFilterComponent,
    AppAmountFilterComponent,
    AppStatusFilterComponent,
    AppCardComponent,
    AppCardAvatarComponent,
    AppCardBadgeComponent,
    AppCardFieldComponent,
    AppCardChipComponent,
    AppCardProgressComponent,
    AppCardStatComponent,
    AppInvoiceCardComponent,
    AppPaymentCardComponent,
    AppWorkOrderCardComponent,
    AppDatePickerComponent,
    AppActionMenuComponent,
    AppActionMenuItemComponent,
    AppActionMenuHeaderComponent,
    AppActionMenuDividerComponent,
    AppTableComponent,
    AppTableTemplateDirective,
    AppProfitMarginFilterComponent,
    AppProductCardComponent,
    AppMultiSelectComponent,
    AppPriceUnitInputComponent,
    AppKpiCardComponent,
    AppQuarterlyMatrixComponent,
    AppMonthSelectorComponent,
    AppFinancialYearFilterComponent,
    ToastComponent,
    AppStatusBadgeComponent,
    AppEditIconButtonComponent,
    AppDeleteIconButtonComponent,
    AppAuditTrailComponent,
    AppAuditTrailNodeComponent,
    AppAuditTrailEntryComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule,
    ClipboardModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
    MatSelectModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatRadioModule,
    NgxUiLoaderModule,
    MatButtonModule,
    MatPaginatorModule,
    MatDialogModule,
    MatMenuModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatInputModule,
    MatRippleModule
  ],
  exports :[
    HeaderComponent,
    SideMenuComponent,
    ConvertMoneyPipe,
    PaginatorComponent,
    FooterComponent,
    IntTelPickerComponent,
    AnotherIntTelPickerComponent,
    ContactIntTelPickerComponent,
    NewDateFilterComponent,
    CustomerSelectionComponent,
    NameSortingComponent,
    StatusFilterComponent,
    DateFormatPipe,
    AgeFilterComponent,
    DueDateFilterComponent,
    AddActionButtonComponent,
    MatPaginatorModule,
    HasAccessDirective,
    PaymentDetailsDrawerComponent,
    InvoiceLoaderDialogComponent,
    ClipboardModule,
    AppLabelComponent,
    AppInputComponent,
    AppSelectComponent,
    AppSearchableDropdownComponent,
    AppCheckboxComponent,
    AppPhoneInputComponent,
    AppRadioComponent,
    AppRadioGroupComponent,
    AppButtonComponent,
    AppPrimaryButtonComponent,
    AppSecondaryButtonComponent,
    AppEditButtonComponent,
    AppActionButtonComponent,
    AppBackButtonComponent,
    AppValueComponent,
    AppDetailFieldComponent,
    AppStepperComponent,
    AppSectionHeaderComponent,
    AppSearchBoxComponent,
    AppSelectFilterComponent,
    AppAmountFilterComponent,
    AppStatusFilterComponent,
    AppCardComponent,
    AppCardAvatarComponent,
    AppCardBadgeComponent,
    AppCardFieldComponent,
    AppCardChipComponent,
    AppCardProgressComponent,
    AppCardStatComponent,
    AppInvoiceCardComponent,
    AppPaymentCardComponent,
    AppWorkOrderCardComponent,
    AppDatePickerComponent,
    AppActionMenuComponent,
    AppActionMenuItemComponent,
    AppActionMenuHeaderComponent,
    AppActionMenuDividerComponent,
    AppTableComponent,
    AppTableTemplateDirective,
    AppProfitMarginFilterComponent,
    AppProductCardComponent,
    AppMultiSelectComponent,
    AppPriceUnitInputComponent,
    AppKpiCardComponent,
    AppQuarterlyMatrixComponent,
    AppMonthSelectorComponent,
    AppFinancialYearFilterComponent,
    ToastComponent,
    AppStatusBadgeComponent,
    AppEditIconButtonComponent,
    AppDeleteIconButtonComponent,
    AppAuditTrailComponent,
    AppAuditTrailNodeComponent,
    AppAuditTrailEntryComponent,
    MatRippleModule
  ],


    providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
